import React from 'react';

import { SMPFlex, SMPImage, styled } from '@velinsi/smp-widgets-ui';
import { StatusType } from '../../../../../packages/types';

interface EventStatusProps {
  dateTime: {
    date: string;
    time: string;
  };
  status: StatusType;
  statusText: string | null;
  competitionLogo: string;
  topEventsSelected?: boolean;
}

export const EventStatus: React.FC<EventStatusProps> = ({ status, dateTime, statusText, competitionLogo, topEventsSelected }) => {
  const setStatusType = (status: string) => (status === StatusType.LIVE ? 'liveStatus' : 'status');

  return (
    <SMPFlex
      justify={'spaceBetween'}
      align={'center'}
      gap={'sm'}
      css={{
        width: '100%',
        height: '$3',
      }}
    >
      <SMPFlex align={'center'} gap={'sm'}>
        {!topEventsSelected && competitionLogo && <SMPImage width={'16px'} src={competitionLogo} />}
        <StatusText type={'date'}>{dateTime.date}</StatusText>
      </SMPFlex>
      {status !== StatusType.NOT_STARTED ? (
        <StatusText type={status === StatusType.CANCELED ? 'postponed' : setStatusType(status)}>{statusText ?? 'Finished'}</StatusText>
      ) : (
        <StatusText type={'date'}>{dateTime.time}</StatusText>
      )}
    </SMPFlex>
  );
};

const StatusText = styled.withConfig({ componentId: 'StatusText', displayName: 'StatusText' })('span', {
  margin: '0',
  fontWeight: 400,
  fontVariantNumeric: 'tabular-nums',
  fontFamily: '$sans',
  fontSize: '$2',
  lineHeight: '16px',
  variants: {
    type: {
      status: {
        color: '$multiSportTextColor',
        fontWeight: 'bold',
      },
      liveStatus: {
        color: '$liveIndicatorColor',
        fontWeight: 'bold',
      },
      postponed: {
        color: '$postponedMatchColor',
        fontWeight: 'bold',
      },
      date: {
        color: '$multiSportCommonColor',
      },
    },
  },
});
